// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gt-table-row{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-flex:row;-webkit-flex:row nowrap;-ms-flex:row nowrap;flex:row nowrap;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;background-color:#fff;border-bottom:1px solid #ccc}", ""]);
// Exports
module.exports = exports;
